<template>
  <el-dropdown trigger="hover" class="lang" @command="handleSetLanguage">
    <span>
      {{ $t('common.p16') }}<i class="el-icon-arrow-down el-icon--right"></i> <span class="lang_icon">{{ language.toUpperCase() }}</span>
    </span>
    <el-dropdown-menu slot="dropdown" class="official-dropdown">
      <el-dropdown-item :disabled="language==='en'" command="en">{{ $t('common.p17') }}</el-dropdown-item>
      <el-dropdown-item :disabled="language==='pt'" command="pt">{{ $t('common.p18') }}</el-dropdown-item>
      <!-- <el-dropdown-item :disabled="language==='ru'" command="ru">{{ $t('common.p19') }}</el-dropdown-item> -->
      <el-dropdown-item :disabled="language==='es'" command="es">{{ $t('common.p20') }}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Cookies from 'js-cookie'
  
export default {
  computed: {
    language () {
      return this.$i18n.locale
    }
  },
  methods: {
    handleSetLanguage (lang) {
      // this.$i18n.locale = lang
      // this.$store.dispatch('setLanguage', lang)
      Cookies.set('language', lang)
      this.$nextTick(() => {
        location.reload()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.lang * {
  color: #ffffff;
}
.lang {
  /deep/.el-dropdown-selfdefine {
    display: inline-block;
    &:focus {
      outline: none;
    }
  }
  .lang_icon {
    background-color: #077594;
    color: #fff!important;
    padding: 0px 4px;
    margin-left: 8px;
  }
}
.official-dropdown {
  // background: rgba(0, 0, 0, 0.85);
  background: #fff;
  border: none;
  /deep/.el-dropdown-menu__item {
    color: #616161;
  }
  /deep/.el-dropdown-menu__item.is-disabled {
    color: #077594;
  }
  /deep/.el-dropdown-menu__item:focus, /deep/.el-dropdown-menu__item:not(.is-disabled):hover {
    background: none!important;
    color: #077594;
  }
  /deep/.popper__arrow {
    display: none;
  }
}
</style>
